var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWordP(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19.0909,
    height: 20,
    rx: 3,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_260_4028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.7942 3.94916H5.95884C5.42878 3.94916 5 4.37407 5 4.89801V16.2842C5 16.8082 5.42878 17.2331 5.95884 17.2331C6.4889 17.2331 6.91768 16.8082 6.91768 16.2842V13.4377H9.7942C12.4376 13.4377 14.5884 11.3093 14.5884 8.72011C14.5884 6.13093 12.437 3.94916 9.7942 3.94916ZM9.7942 11.5397H6.91768V5.84686H9.7942C11.3805 5.84686 12.6707 7.12366 12.6707 8.69342C12.6707 10.2632 11.3793 11.5397 9.7942 11.5397Z",
    fill: "#495376"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_260_4028"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.5884,
    height: 15.1816,
    fill: "white",
    transform: "translate(5 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordP);
export default __webpack_public_path__ + "static/media/word_p.8b37ed314b174fdb41c74350fe914a58.svg";
export { ForwardRef as ReactComponent };